import * as RewardCard from 'root/src/client/web/giveaway/components/RewardCard';
import { platformIconMap } from 'root/src/shared/constants/dropKeys';
import SuccessIcon from 'root/src/client/web/giveaway/assets/ic-success.svg';
import ButtonNew from 'root/src/client/web/base/ButtonNew';
import { useRedeemModal, } from 'root/src/client/web/giveaway/features/RedeemModal/hooks/useReedemModal';
import { Cup, CupSize, CupVariant } from 'root/src/client/web/giveaway/components/Cup';
import { GiveawayRewardStatus } from 'root/src/client/web/giveaway/giveaway.types';
import { useModal, ModalContextProvider, DEFAULT_MODAL_OPTIONS } from 'root/src/client/v2/common/contexts/modal.context';
import { memo, useCallback } from 'react';
import classnames from 'classnames';
import RedeemConfirmationModal from 'root/src/client/web/giveaway/features/RedeemModalConfirmation/RedeemConfirmationModal';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import { RewardsCarousel } from 'root/src/client/web/giveaway/components/RewardsCarousel/RewardsCarousel';
import NumberFlow from '@number-flow/react';
export const RedeemModal = memo(() => {
    const { rewards, claimedRewards, totalVouchers, onRedeem, } = useRedeemModal();
    const isPlural = totalVouchers > 1;
    const renderReward = useCallback((reward) => {
        const isDisabled = reward.isClaimed;
        const isRedeemed = (reward === null || reward === void 0 ? void 0 : reward.status) === GiveawayRewardStatus.REDEEMED;
        const region = 'region' in reward ? `(${reward.region})` : '';
        return (<div className="h-96 w-full break-all flex flex-initial items-center justify-center select-none">
				<RewardCard.Root className={classnames('h-full border-2 relative', isDisabled ? 'border-gray-1' : 'border-teal')}>
					{(isRedeemed || isDisabled) && (<RewardCard.ClaimedLabel />)}
					<RewardCard.AvailableBadge available={reward.available}/>
					<RewardCard.ImageContainer className={classnames('justify-center items-center', isDisabled ? 'border-gray-1' : '')}>
						<RewardCard.GameImage src={reward.image} alt={reward.name}/>
						{isRedeemed ? (<img src={SuccessIcon.src} alt="Success" className="absolute"/>) : (<RedeemButton onRedeem={() => onRedeem(reward)} reward={reward} isClaimed={reward.isClaimed}/>)}
					</RewardCard.ImageContainer>
					<RewardCard.GameTitle className="mt-2" title={reward.name}/>
					<RewardCard.Details>
						<RewardCard.RewardTitle className={classnames(isDisabled ? 'text-gray-1' : '')}>
							{reward.name} code <span className="capitalize text-inherit">{region}</span>
						</RewardCard.RewardTitle>
						{typeof reward.platform === 'string' && <RewardCard.PlatformIcon icon={platformIconMap[reward.platform]}/>}
					</RewardCard.Details>
				</RewardCard.Root>
			</div>);
    }, [onRedeem]);
    return (<ModalLayout className="sm:min-w-[640px] md:min-w-[720px] lg:min-w-[800px] xl:min-w-[900px] 2xl:min-w-[1000px]">
			<ModalContextProvider className="w-full">
				<div className="flex flex-col items-center gap-3 w-full">
					<h1 className="uppercase font-mono text-2xl font-bold text-center select-none">Congrats<br />You are the winner!</h1>
					<Cup className="select-none" variant={CupVariant.Gold} size={CupSize.LARGE}/>
					<h2 className="font-mono text-xl font-bold select-none">Select your Reward</h2>
					<span className="text-teal text-sm select-none">You have {totalVouchers} reward{isPlural ? 's' : ''} to redeem:</span>
					<span className="text-sm font-bold bg-teal text-dark-2 px-4 py-1.5 rounded-xl tracking-widest select-none">
						<NumberFlow className="text-dark-2" value={claimedRewards.length}/> / <NumberFlow className="text-dark-2" value={totalVouchers}/>
					</span>
					<div className="flex flex-col gap-2 justify-center items-center w-full">
						<span className="uppercase text-light-4 text-xs select-none">Reward giveaway options</span>
						<RewardsCarousel rewards={rewards} renderReward={renderReward} containerClassName="pt-4" slideClassName="flex-[0_0_40%] md:flex-[0_0_20%] flex justify-center items-center"/>
					</div>
				</div>
			</ModalContextProvider>
		</ModalLayout>);
});
const RedeemButton = memo((props) => {
    const { onRedeem, isClaimed } = props;
    const modal = useModal();
    return (<ButtonNew onClick={() => {
            modal.show(<RedeemConfirmationModal reward={props.reward} onRedeem={onRedeem}/>, { zIndex: DEFAULT_MODAL_OPTIONS.zIndex + 10 });
        }} className="hidden group-hover:flex absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" type="secondary" disabled={isClaimed}>
			<span className="text-lg text-inherit">{isClaimed ? 'Claimed' : 'Redeem'}</span>
		</ButtonNew>);
});
